/**
 * 设置数据保留的小数位数
 * @param {*} value 需要设置的数据
 * @param {*} param1 num保留位数，keepInt整数数据是否保留整数状态
 *///, { num = 2, keepInt = true }
// let decimal = (value) => {
//     console.log(value);
//     return value;
// }
let methods = {
    /**
     * 设置数据保留的小数位数
     * value 需要设置的数据
     * param num保留位数，keepInt整数数据是否保留整数状态，zero是否使用0补全
     */
    decimal: function (value, param) {
        // console.log('decimal', value);
        param = { ...{ num: 2, keepInt: true, zero: false }, ...param };
        value = parseFloat(value);
        let valueStr = value.toString();
        if (
            (valueStr).indexOf('.') != -1 ||
            (!param.keepInt && (valueStr).indexOf('.') == -1)
        ) {
            let decimalStr = (valueStr.split('.'))[1];
            let decimalLen = decimalStr ? decimalStr.length : 0;
            if (param.zero || decimalLen > param.num)
                value = value.toFixed(param.num);
        }
        return value.toString();
    },
    /**
     * 设置成百分比模式
     */
    percentage: function (value, param) {
        // console.log('percentage', value);
        param = { ...{ num: 2, keepInt: false }, ...param };
        value = this.decimal(value * 100, param);
        return value + '%';
    }
}
/**
 * 
 * @param {*} value 
 * @param {*} param 
 * 格式：
 * 'decimal'
 * {key:'decimal',param:{}}
 * [{key:'decimal',param:{}}]
 */
let filterMethod = (value, param) => {
    let result = value;
    if (!param) {
        result = value;
    } else if (Array.isArray(param)) {
        for (let i = 0; i < param.length; i++) {
            let data = param[i];
            result = methods[data.key](result, data.param);
        }
    } else if (typeof (param) == 'string') {
        result = methods[param](result);
    } else {
        result = methods[param.key](result, param.param);
    }
    return result;
}

export { methods };
export default filterMethod;
// module.exports = { methods };


// WEBPACK FOOTER //
// ./src/public/utils/filterUtils.js